import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  MenuItem,
  Grid,
  DialogContentText,
  Button,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import ContainerWithTitle from '../../containers/HOC/ContainerWithTitle'
import { EditableSelect, EditableInput } from '../common/EditableComponents'
import { categoryTypes, unitTypes, archivedCategories } from '../../utils/common'
import TextError from './TextError'
import {
  updateMasterCategories,
  bulkUpdateChildCategories,
  updateOrphanCategories,
} from '../../actions/masterCatalog'

class ModalUpdateMasterCategory extends Component {
  constructor(props) {
    super(props)

    this.state = {
      scroll: 'paper',
      cannabis: null,
      unitType: null,
      lowThreshold: null,
      archived: null,
      error: false,
      message: '',
    }
  }

  handleChange = (state, value) => {
    this.setState({
      [state]: value.target.value,
    })
  }

  updateMasterCategory = () => {
    const { optionToBulkUpdate, masterCategories, processOnGrid } = this.props
    if (this.state[optionToBulkUpdate.field] != null) {
      let fieldName = optionToBulkUpdate.field
      if (fieldName === 'cannabis') fieldName = 'isCannabis'

      if (this.props.typeCategory == 'master') {
        var data = {
          masterIds: masterCategories.map((c) => c.id),
          bulkType: optionToBulkUpdate.action,
          [fieldName]: this.state[optionToBulkUpdate.field],
        }

        const childMasterCategories = masterCategories.map((c) => c.childCategories || [c]) || []
        this.props.dispatch(updateMasterCategories(data)).then(() => {
          masterCategories.forEach((master) => {
            childMasterCategories.forEach((children) => {
              const childrenSourceMapParent = children.filter(
                (c) =>
                  c.sourceMap &&
                  (masterCategories[0].parentCategoryId ||
                    c.sourceMap[optionToBulkUpdate.field] == 'PARENT'),
              )
              childrenSourceMapParent.forEach((child) => {
                const dataChild = {
                  childCategoriesIds: [child.id],
                  bulkType: optionToBulkUpdate.action,
                  [fieldName]: this.state[optionToBulkUpdate.field],
                  sourceMap: {
                    ...child.sourceMap,
                    [optionToBulkUpdate.field]: masterCategories[0].parentCategoryId
                      ? 'CHILD'
                      : 'PARENT',
                  },
                }
                this.props.dispatch(bulkUpdateChildCategories(dataChild))
              })
            })
          })
          processOnGrid([])
          this.closeModal(true)
        })
      } else {
        var data = {
          orphanIds: masterCategories.map((c) => c.id),
          bulkType: optionToBulkUpdate.action,
          [fieldName]: this.state[optionToBulkUpdate.field],
        }
        this.props.dispatch(updateOrphanCategories(data)).then(() => {
          processOnGrid([])
          this.closeModal(true)
        })
      }
    } else {
      this.setState({
        error: true,
        message: 'El campo es requerido',
      })
    }
  }

  getComponentToUpdate = (options) => {
    const { cannabis, unitType, lowThreshold, archived } = this.state
    switch (options.field) {
      case 'cannabis':
        return (
          <Grid container className="center-aligned-child">
            <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
              <label className="label-modal">Category Type</label>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <EditableSelect
                editMode={true}
                material={false}
                name="cannabis"
                value={cannabis}
                onChange={(value) => this.handleChange('cannabis', value)}
                valueToRender={cannabis}
              >
                {categoryTypes.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item.value}>
                      {item.label}
                    </MenuItem>
                  )
                })}
              </EditableSelect>
            </Grid>
          </Grid>
        )
      case 'unitType':
        return (
          <Grid container className="center-aligned-child">
            <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
              <label className="label-modal">Measurement</label>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <EditableSelect
                name="unitType"
                editMode={true}
                material={false}
                value={unitType}
                onChange={(value) => this.handleChange('unitType', value)}
                valueToRender={unitType}
              >
                {unitTypes.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item.value}>
                      {item.label}
                    </MenuItem>
                  )
                })}
              </EditableSelect>
            </Grid>
          </Grid>
        )
      case 'lowThreshold':
        return (
          <Grid container className="center-aligned-child">
            <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
              <label className="label-modal">LIT</label>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <EditableInput
                name="lowThreshold"
                placeholder={'Enter Low Threshold'}
                editMode={true}
                material={false}
                type="number"
                value={lowThreshold}
                onChange={(value) => this.handleChange('lowThreshold', value)}
                valueToRender={lowThreshold}
              />
            </Grid>
          </Grid>
        )
      case 'archived':
        return (
          <Grid container className="center-aligned-child">
            <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
              <label className="label-modal">Archived</label>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <EditableSelect
                name="archived"
                editMode={true}
                material={false}
                value={archived}
                onChange={(value) => this.handleChange('archived', value)}
                valueToRender={archived}
              >
                {archivedCategories.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item.value}>
                      {item.label}
                    </MenuItem>
                  )
                })}
              </EditableSelect>
            </Grid>
          </Grid>
        )
      default:
        break
    }
  }

  closeModal = (update = false) => {
    this.setState({
      cannabis: null,
      unitType: null,
      lowThreshold: null,
      archived: null,
      error: false,
    })
    this.props.handleClose(update)
  }

  renderValue = (row) => {
    const { optionToBulkUpdate } = this.props
    let value = ''
    switch (optionToBulkUpdate.field) {
      case 'cannabis':
        value = row[optionToBulkUpdate.field] ? 'Cannabis' : 'Non-Cannabis'
        break
      case 'archived':
        value = row['statusName'] && row['statusName'] === 'archived' ? 'Yes' : 'No'
        break
      default:
        value = row[optionToBulkUpdate.field]
        break
    }
    return value
  }

  render() {
    const { open, handleClose, masterCategories, optionToBulkUpdate } = this.props
    const { scroll, error, message } = this.state
    const category = masterCategories[0] || []
    return (
      <div>
        {masterCategories.length > 0 ? (
          <Dialog
            open={open}
            onClose={handleClose}
            scroll={scroll}
            aria-labelledby="scroll-dialog-title"
          >
            <DialogTitle id="scroll-dialog-title">Bulk Update</DialogTitle>
            <DialogContent>
              {optionToBulkUpdate && (
                <React.Fragment>
                  <div className="container-field-update-master-product padding-small">
                    {this.getComponentToUpdate(optionToBulkUpdate)}
                    <TextError error={error} message={message} />
                  </div>
                  <Paper className="container-table">
                    <Table>
                      <TableHead className="table-header">
                        <TableRow>
                          {!category.childCategories ? <TableCell>Shop</TableCell> : null}
                          <TableCell>Category Name</TableCell>
                          <TableCell>{optionToBulkUpdate.name}</TableCell>
                          {masterCategories && masterCategories[0].parentCategoryId && (
                            <TableCell>Linked</TableCell>
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {masterCategories.map((row, index) => {
                          return (
                            <TableRow key={index}>
                              {!category.childCategories ? (
                                <TableCell component="th" scope="row">
                                  {row.shop && row.shop.name}
                                </TableCell>
                              ) : null}
                              <TableCell component="th" scope="row">
                                {row.name}
                              </TableCell>
                              <TableCell>{this.renderValue(row)}</TableCell>
                              {row.sourceMap &&
                                row.parentCategoryId &&
                                (row.sourceMap[optionToBulkUpdate.field] == 'PARENT' ? (
                                  <TableCell>Yes</TableCell>
                                ) : (
                                  <TableCell>No</TableCell>
                                ))}
                            </TableRow>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </Paper>
                </React.Fragment>
              )}
            </DialogContent>
            <DialogActions>
              <div className="container-form-bulk-update-buttons">
                <Button
                  className="button-white-and-red"
                  onClick={() => {
                    this.closeModal(false)
                  }}
                >
                  <span className="button-text">Cancel</span>
                </Button>
                <Button
                  className="button-blue-and-white"
                  variant="contained"
                  onClick={this.updateMasterCategory}
                >
                  <span className="button-text">Save</span>
                </Button>
              </div>
            </DialogActions>
          </Dialog>
        ) : (
          <Dialog
            open={open}
            onClose={() => {
              this.closeModal(false)
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">Bulk Update</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Select master categories
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  this.closeModal(false)
                }}
                className="button-blue-and-white"
                autoFocus
              >
                <span className="button-text">Accept</span>
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </div>
    )
  }
}

const ModalUpdateMasterCategoryWithTitle = ContainerWithTitle(
  ModalUpdateMasterCategory,
  'Master Categories',
)

const ModalUpdateMasterCategoryConnected = connect(({ dispatch }) => ({
  dispatch,
}))(ModalUpdateMasterCategoryWithTitle)

export default ModalUpdateMasterCategoryConnected



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/ModalUpdateMasterCategory.js